import styled from '@emotion/styled';
import { GUTTER_WIDTH, NUMBER_OF_COLUMNS } from './config';
import { BreakpointValue } from 'consts/breakpoints';

interface ColProps {
  from1?: number;
  from2?: number;
  from3?: number;
  from4?: number;
  from5?: number;
}

const getColumnConfigFromProps = (props: ColProps) => (
  [ props.from1, props.from2, props.from3, props.from4, props.from5 ]
);

const getWidthAtBreakpoint = (columnsConfig: ReturnType<typeof getColumnConfigFromProps>) => {
  const normalizedConfig = columnsConfig.reduce((acc, config, index) => {
    if (!config && acc[index - 1]) {
      acc.push(acc[index - 1]);
    }
    else {
      acc.push(config);
    }

    return acc;
  }, []);

  return normalizedConfig.map(columns => columns ? `${(100 / NUMBER_OF_COLUMNS) * columns}%` : '100%');
};


export const Col = styled.div<ColProps>`
  padding-left: ${GUTTER_WIDTH / 2}px;
  padding-right: ${GUTTER_WIDTH / 2}px;
  flex-shrink: 0;
  flex-basis: 100%;

  ${({ theme, ...props }) => {
    const widths = getWidthAtBreakpoint(getColumnConfigFromProps(props));
    const isEmptyConfig = !widths.filter(width => width !== '100%').length;

    return widths.map((width: string, index: number) => () =>
      theme.media.showAt({ at: (index + 1) as BreakpointValue })`
        flex-basis: ${isEmptyConfig ? '0' : width};
        flex-grow: ${isEmptyConfig ? '1' : 0};
        max-width: ${isEmptyConfig ? '100%' : width};
      `);
  }}
`;

